/**
 * 套餐产品名称兜底字典。
 *
 * 用途：当 GetCombosInfo 接口未返回某个套餐 id 的 name 时，使用此处的中文兜底名做展示。
 * 国际化：本字典中的中文 value 也是 i18n key —— 调用方均会通过 $t(value) 渲染，
 *        翻译字典（本地 lang 包 + 后端 GetI18nTextMap）需覆盖这些套餐名。
 */

export const packageInfo = {
    10002: '企点-商通基础版',
    10003: '企点客服-在线客服标准版',
    10004: '企点分析',
    10005: '企点客服-电话客服标准版',
    10007: '企点客服-在线客服企业版',
    10008: '企点客服-电话客服专业版',
    10009: '企点客服-在线客服专业版',
    10010: '企点营销企业版',
    10011: '企点商圈标准版',
    10012: '企点领航企业应用',
    10013: '企点商通-行业版',
    10015: '企点电话客服',
    10016: '企点-企业QQ 2.0 (协同)',
    10017: '企点客服-在线客服基础版',
    10018: '企点营销标准版',
    10019: '企点营销-智推专业版',
    10020: '八戒企业QQ免费版',
    10021: '八戒企业QQ增值版',
    10022: '企点商铺-标准版',
    10023: '腾讯企点-在线客服（平台基础版）',
    10024: '腾讯企点-在线客服（平台标准版）',
    10025: '企点营销-会销标准版',
    10026: '腾讯企点-云呼叫中心 (专业版)',
    10027: '腾讯企点-云呼叫中心 (企业版)',
    10028: '企点营销-社交零售解决方案',
    10035: '企点营销-智推标准版',
    10036: '展会定制客服基础版',
    10037: '企点商通-物流版',
    10039: '企点客服标准版（云官网）',
    10040: '企点客服专业版（云官网）',
};

export default packageInfo;
